import React from 'react'
import { routerStore } from '~/stores'
import { logClickEvent } from '~/common/tracking/event-client.tracking'
import { COMMON_EVENT_CLICK_TRACKING } from '~/common/constants/tracking.constant'
import { PATHS } from '~/common/constants'
import { Box } from '@material-ui/core'
import { Button } from '~/components/button'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { SubHeaderWrapper } from './sub-header.style'

export const SubHeader = ({ top }) => {
	const { t } = useTranslation()

	const handleRedirectSignIn = () => {
		logClickEvent(COMMON_EVENT_CLICK_TRACKING.signInBtn, {})
		routerStore.goPage(PATHS.common.signin)
	}

	const handleRedirectSignUp = () => {
		logClickEvent(COMMON_EVENT_CLICK_TRACKING.signUpBtn, {})
		routerStore.goPage(PATHS.common.signup)
	}

	return (
		<SubHeaderWrapper top={top}>
			<Box className="layout-sub-nav">
				<Box display={'flex'} alignItems={'center'}>
					<Button onClick={handleRedirectSignIn} className={'top-bar-ano-button'} color={'primary'}>
						{t('SIGN_IN')}
					</Button>
					<Button onClick={handleRedirectSignUp} className={'top-bar-ano-button'} variant="outlined">
						{t('SIGN_UP')}
					</Button>
				</Box>
			</Box>
		</SubHeaderWrapper>
	)
}

